import type * as React from 'react';

import * as api from '@gitbook/api-client';
import { ActionableContainer, Heading, Panel, PanelBody, Switch } from '@gitbook/spine-react';

import type { SitesCustomizationPanelProps } from '../../types';
import { HeaderNavigationSettings } from './HeaderNavigation';
import { HeaderSearchStyleSettings } from './HeaderSearchStyleSettings';

export function PanelHeader(props: SitesCustomizationPanelProps): React.ReactElement {
    const { settings, setSettings } = props;
    const headerEnabled = settings.header.preset !== api.CustomizationHeaderPreset.None;

    return (
        <Panel>
            <ActionableContainer orientation="horizontal">
                <Heading>Header</Heading>
                <Switch
                    value={headerEnabled}
                    onValueChange={(checked) => {
                        setSettings((prev) => ({
                            ...prev,
                            header: {
                                ...prev.header,
                                preset: checked
                                    ? api.CustomizationHeaderPreset.Default
                                    : api.CustomizationHeaderPreset.None,
                            },
                        }));
                    }}
                />
            </ActionableContainer>
            {headerEnabled ? (
                <PanelBody>
                    <HeaderSearchStyleSettings {...props} />
                    <HeaderNavigationSettings {...props} />
                </PanelBody>
            ) : null}
        </Panel>
    );
}
